import React from 'react';
import { SelectBase, makeCreatableSelect } from 'react-select';

import { SelectSingleValue, SelectSingleValueStyles } from './SelectSingleValue';
import { SelectMultiValue, SelectMultiValueStyles } from './SelectMultiValue';
import { SelectClearIndicator, SelectClearIndicatorStyles } from './SelectClearIndicator';
import { SelectIndicatorSeparator, SelectIndicatorSeparatorStyles } from './SelectIndicatorSeparator';
import { SelectControl, SelectControlStyles } from './SelectControl';
import { SelectDropdownIndicator, SelectDropdownIndicatorStyles } from './SelectDropdownIndicator';
import { SelectMenu, SelectMenuStyles } from './SelectMenu';
import { SelectMenuList, SelectMenuListStyles } from './SelectMenuList';
import { SelectOption, SelectOptionStyles } from './SelectOption';
import { SelectContainer } from './SelectContainer';
import { SelectValueContainer } from './SelectValueContainer';
import { SelectInput } from './SelectInput';
import { withCreatableCreateOnEnterOrTab } from './behaviors/withCreatableCreateOnEnterOrTab';
import { withState } from './behaviors/withState';

const defaultProps = {
    isCreatable: false,
    styles: {},
    components: {},
    defaultValue: undefined,
    defaultInputValue: undefined,
};

export const SelectStyles = {
    control: SelectControlStyles,
    singleValue: SelectSingleValueStyles,
    multiValue: SelectMultiValueStyles,
    clearIndicator: SelectClearIndicatorStyles,
    indicatorSeparator: SelectIndicatorSeparatorStyles,
    dropdownIndicator: SelectDropdownIndicatorStyles,
    menu: SelectMenuStyles,
    menuList: SelectMenuListStyles,
    option: SelectOptionStyles,
};

export const SelectComponents = {
    Control: SelectControl,
    SingleValue: SelectSingleValue,
    MultiValue: SelectMultiValue,
    IndicatorSeparator: SelectIndicatorSeparator,
    ClearIndicator: SelectClearIndicator,
    DropdownIndicator: SelectDropdownIndicator,
    Menu: SelectMenu,
    MenuList: SelectMenuList,
    Option: SelectOption,
    SelectContainer,
    ValueContainer: SelectValueContainer,
    Input: SelectInput,
};

const ReactSelect = withState(SelectBase);
const ReactCreatable = withState(withCreatableCreateOnEnterOrTab(makeCreatableSelect(SelectBase)));

const Select = ({
    styles,
    components = {},
    isCreatable = false,
    ...props
}) => {
    const SelectComponent = isCreatable ? ReactCreatable : ReactSelect;
    return (
        <SelectComponent
            {...props}
            styles={{
                ...SelectStyles,
                ...styles,
            }}
            components={{
                ...SelectComponents,
                ...components,
            }}
        />
    );
};

Select.defaultProps = defaultProps;

export { Select };
